import fetchDesigners from "./fetchDesigners"
import customerReady from "./customerReady";

export default function saveDesignersCustomer(designers) {
  return Promise.all([fetchDesigners(), customerReady])
    .then(([designersCache]) => {
      const designersMap = designersCache.reduce((map, curr) => {
        map[curr.handle] = curr.id;
        return map;
      }, {});

      const data = designers.map(designer => ({ handle: designer, id: designersMap[designer] }));

      CF.customer.set('follow_designers', data);

      return CF.customer.save();
    });
}
